const DEFAULT_PRIMARY_COLOR = "#ff6647";
const DEFAULT_SECONDARY_COLOR = "#d6008f";

export default function (editor) {
  let wrapper;

  const wrapperUpdate = () => {
    wrapper = editor.getWrapper();
    wrapper &&
      wrapper.get("traits").add([
        {
          name: "data-color-primary",
          type: "color",
          label: "Primary color",
        },
        {
          name: "data-color-secondary",
          type: "color",
          label: "Secondary color",
        },
      ]);
  };

  editor.on("storage:loaded", () => {
    wrapperUpdate();
    const doc = editor.Canvas.getDocument() as HTMLDocument;
    const styles = doc.head.querySelector("#colors") || doc.head.appendChild(doc.createElement("style"));

    const primaryColor = styles.getAttribute("data-color-primary") || wrapper.getAttributes()["data-color-primary"] || DEFAULT_PRIMARY_COLOR;
    const secondaryColor = styles.getAttribute("data-color-secondary") || wrapper.getAttributes()["data-color-secondary"] || DEFAULT_SECONDARY_COLOR;
    wrapper.addAttributes({ [`data-color-primary`]: primaryColor });
    wrapper.addAttributes({ [`data-color-secondary`]: secondaryColor });
    styles.id = "colors";
    styles.innerHTML = `:root {
      --palette-primary: ${primaryColor};
      --palette-secondary: ${secondaryColor};
    }`;
    styles.setAttribute("data-color-primary", primaryColor);
    styles.setAttribute("data-color-secondary", secondaryColor);
  });

  editor.on("storage:start:store", () => {
    const doc = editor.Canvas.getDocument() as HTMLDocument;

    const primaryColor = wrapper.getAttributes()["data-color-primary"] || DEFAULT_PRIMARY_COLOR;
    const secondaryColor = wrapper.getAttributes()["data-color-secondary"] || DEFAULT_SECONDARY_COLOR;

    const styles = doc.head.querySelector("#colors") || doc.head.appendChild(doc.createElement("style"));
    styles.id = "colors";
    styles.innerHTML = `:root {
      --palette-primary: ${primaryColor};
      --palette-secondary: ${secondaryColor};
    }`;
    styles.setAttribute("data-color-primary", primaryColor);
    styles.setAttribute("data-color-secondary", secondaryColor);
  });
}
